import { Link } from "react-router-dom";

const entries = [
  {
    to: "/category/movie",
    icon: "ri-movie-2-line",
    title: "电影",
    desc: "院线新片与经典佳作",
    accent: "bg-primary-100 text-primary-700",
  },
  {
    to: "/category/tv",
    icon: "ri-tv-2-line",
    title: "电视剧",
    desc: "都市情感与年代好剧",
    accent: "bg-accent-100 text-accent-700",
  },
  {
    to: "/category/variety",
    icon: "ri-mic-line",
    title: "综艺",
    desc: "竞技真人秀与生活慢综",
    accent: "bg-secondary-100 text-secondary-900",
  },
  {
    to: "/category/actor",
    icon: "ri-user-star-line",
    title: "演员资料",
    desc: "热门演员与代表作品",
    accent: "bg-primary-100 text-primary-700",
  },
];

export default function CategoryQuickEntry() {
  return (
    <section className="max-w-content mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <h2 className="font-heading font-black text-xl md:text-2xl text-foreground-950">
            影视分类快捷入口
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            按类型快速进入对应频道，浏览更高效。
          </p>
        </div>
      </div>
      <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {entries.map((e) => (
          <Link
            key={e.to}
            to={e.to}
            className="group p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
          >
            <span
              className={`w-12 h-12 flex items-center justify-center rounded-md ${e.accent}`}
            >
              <i className={`${e.icon} text-2xl`} />
            </span>
            <h3 className="mt-4 font-heading font-bold text-lg text-foreground-950">
              {e.title}
            </h3>
            <p className="mt-1 text-sm text-foreground-500">{e.desc}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-sm text-accent-600">
              进入频道
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}